import { Locale } from '@framework/i18n';
import { Dropdown } from '@framework/ui';
import { ItemType } from 'antd/es/menu/interface';
import clx from 'classnames';
import React from 'react';
import { LanguageButton } from '../../ui/menu/LanguageButton';
import { MobileMenuLabel } from '../../ui/menu/MobileMenuLabel';

interface MobileLanguageMenuProps {
  selected: Locale;
  locales: Locale[];
  onSelected: (locale: Locale) => void;
}

export function MobileLanguageMenu(props: MobileLanguageMenuProps) {
  const { selected, locales, onSelected } = props;
  const menuItems = locales.map(locale => ({
    key: locale.tag,
    label: (
      <MobileMenuLabel>{locale.nativeName ?? locale.name}</MobileMenuLabel>
    ),
    title: locale.label,
    onClick: () => onSelected(locale),
  })) satisfies ItemType[];

  return (
    <Dropdown
      menu={{ items: menuItems }}
      trigger={['click']}
      placement="bottomRight"
      autoFocus
      data-testid="mobile-language-menu"
    >
      <LanguageButton aria-haspopup className={clx(['selected'])}>
        {selected.label}
      </LanguageButton>
    </Dropdown>
  );
}
